import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@ortho-next/auth-core';
import { APP_CONFIG, LanguageService, PAGE } from '../../core';
import { CookieBannerService, UserService } from '../../services';
import { BaseComponent } from '../../shared';


/**
 * Vertical bar on the left.
 */
@Component({
	selector: 'sidebar',
	templateUrl: './sidebar.component.html',
	imports: [
		RouterLink,
		RouterLinkActive,
		NgbDropdownModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class SidebarComponent extends BaseComponent {

	private readonly router = inject(Router);
	private readonly config = inject(APP_CONFIG);
	private readonly authSrv = inject(AuthService);
	private readonly userSrv = inject(UserService);
	protected override readonly langSrv = inject(LanguageService);
	private readonly cookieBannerSrv = inject(CookieBannerService);

	buildVersion = this.config.buildVer;
	envName = this.config.envName;
	readonly PAGE = PAGE;


	/**
	* Navigate to edit profile page.
	*/
	editProfile(): void {
		this.router.navigateByUrl(`/${PAGE.PROFILE_EDIT}`);
	}

	/**
	* Open legal terms page.
	*/
	openLegalTerms(): void {
		this.userSrv.getUserCountry().subscribe(code => {
			window.open(`${this.config.legalTermsSite}?countryCode=${code}`);
		});
	}

	/**
	* Open about page.
	*/
	openAboutPage(): void {
		window.open(`${this.config.aboutSite}${this.langSrv.currentLang}`, '_blank');
	}

	/**
	* Change password.
	*/
	changePassword(): void {
		this.authSrv.changePassword();
	}

	/**
	 * Open cookie preferences modal.
	 */
	openCookieModal(): void {
		this.cookieBannerSrv.openPreferencesModal();
	}

	/**
	* Logout.
	*/
	logout(): void {
		this.authSrv.singleSignOut();
	}
}
